import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac89f1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-top-tab-nav" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "down" }
const _hoisted_4 = { class: "icon-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_svg = _resolveComponent("icon-svg")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "left",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleScroll(200)))
    }, [
      _createVNode(_component_icon_svg, {
        class: "icon",
        type: "arrow-left"
      })
    ]),
    _createElementVNode("div", {
      class: "middle",
      ref: "scrollBox",
      "on:DOMMouseScroll": _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRolling && _ctx.handleRolling(...args))),
      onMousewheel: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleRolling && _ctx.handleRolling(...args)))
    }, [
      _createElementVNode("div", {
        class: "tab",
        ref: "scrollContent",
        style: _normalizeStyle({transform: `translateX(${_ctx.translateX}px)`})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabNavList, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            ref_for: true,
            ref: _ctx.tabNavSpanRef,
            key: `tab-nav-${index}`,
            class: _normalizeClass(["item", {'active': _ctx.equalTabNavRView(_ctx.route, item.route, item.menu.tabNavType)}]),
            onClick: ($event: any) => (_ctx.toRoute(item,index))
          }, [
            _createVNode(_component_icon_svg, {
              class: "icon-pre",
              type: "refresh",
              onClick: _withModifiers(($event: any) => (_ctx.refreshCurrentTabNav(item)), ["stop"])
            }, null, 8, ["onClick"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.t(item.menu.title)), 1),
            (item.menu.path!==_ctx.homeRouteItemPath)
              ? (_openBlock(), _createBlock(_component_icon_svg, {
                  key: 0,
                  class: "icon",
                  type: "close",
                  onClick: _withModifiers(($event: any) => (_ctx.closeCurrentTabNav(item, index)), ["stop"])
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_2))
        }), 128))
      ], 4)
    ], 544),
    _createElementVNode("div", {
      class: "right",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleScroll(-200)))
    }, [
      _createVNode(_component_icon_svg, {
        class: "icon",
        type: "arrow-right"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, {
            onClick: _cache[4] || (_cache[4] = (e)=>_ctx.handleCommandMore(e.key))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, { key: "closeleft" }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_svg, {
                    class: "icon-dropdown-menu",
                    type: "arrow-left2"
                  }),
                  _createTextVNode(" 关闭左侧")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, { key: "closeright" }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_svg, {
                    class: "icon-dropdown-menu",
                    type: "arrow-right2"
                  }),
                  _createTextVNode(" 关闭右侧")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, { key: "closeother" }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_svg, {
                    class: "icon-dropdown-menu",
                    type: "close"
                  }),
                  _createTextVNode(" 关闭其他")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, { key: "closeall" }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_svg, {
                    class: "icon-dropdown-menu",
                    type: "close2"
                  }),
                  _createTextVNode(" 关闭所有")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_icon_svg, {
              class: "icon",
              type: "more"
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}